import {
  View,
  Text,
  SafeAreaView,
  Platform,
  StatusBar,
  I18nManager,
} from "react-native";
import React from "react";
import HeaderProfileIcon from "../header/HeaderProfileIcon";
import MyText from "../custom/MyText";
import Wallet from "./Wallet";
import SectionButton from "./SectionButton";
import translate from "../../functions/translate";
import Dropdown from "../custom/Dropdown";
import Cookies from "universal-cookie";
import { primary, success } from "../../colors";
import PersonIcon from "../../assets/svg/PersonIcon";
import SupportIcon from "../../assets/svg/SupportIcon";
import InfoIcon from "../../assets/svg/InfoIcon";
import LogoutIcon from "../../assets/svg/LogoutIcon";
import LoginIcon from "../../assets/svg/LoginIcon";
import PersonAddIcon from "../../assets/svg/PersonAddIcon";
import { useDispatch, useSelector } from "react-redux";
import { setLoginModal } from "../../redux/modal/modalAction";
import { useNavigation } from "@react-navigation/native";
import { useState } from "react";
import { useEffect } from "react";
import { storeStringData } from "../../functions/db/db";
import * as Updates from "expo-updates";

const cookies = new Cookies();

export default function NotLoggedIn() {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const [items, setItems] = useState([
    { id: 1, name: "فارسی" },
    { id: 2, name: "English" },
  ]);
  const main = useSelector((store) => store.main);
  let currentSelected = main.rtl ? 1 : 2;
  const [selected, setSelected] = useState({ selected: main.rtl ? 1 : 2 });
  useEffect(() => {
    if (currentSelected !== selected.selected) {
      currentSelected = selected.selected;

      if (Platform.OS === "web") {
        if (selected.selected === 2) {
          cookies.set("language", "english");
          location.reload();
        } else {
          cookies.set("language", "persian");
          location.reload();
        }
      }
      if (selected.selected === 2) {
        I18nManager.forceRTL(false);
        I18nManager.allowRTL(false);
        storeStringData("languageSet", "english");
        Updates.reloadAsync();
      } else {
        I18nManager.forceRTL(true);
        I18nManager.allowRTL(true);
        storeStringData("languageSet", "english");
        //   setTimeout(() => dispatch(setConfirmLanguageModal()), 700);
        Updates.reloadAsync();
      }
    }
  }, [selected]);
  return (
    <SafeAreaView
      style={{
        flex: 1,
        paddingTop: Platform.OS === "android" ? StatusBar.currentHeight : 0,
      }}
      dir={cookies.get("language") === "english" ? "ltr" : "rtl"}
    >
      <View style={{ padding: 10 }}>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <HeaderProfileIcon />
        </View>
        <View style={{ marginVertical: 20 }}>
          <MyText>{translate("you are not logged in")}</MyText>
        </View>

        <View>
          <SectionButton
            onPress={() => {
              dispatch(setLoginModal(true));
            }}
            name={translate("login")}
            icon={LoginIcon}
            iconPlaceStyle={{ backgroundColor: success, borderColor: success }}
            textStyle={{ color: success }}
            style={{ borderBottomColor: success }}
          />
          <SectionButton
            onPress={() => navigation.navigate("UserRegister")}
            name={translate("signup")}
            icon={PersonAddIcon}
            iconPlaceStyle={{ backgroundColor: primary, borderColor: primary }}
            textStyle={{ color: primary }}
            style={{ borderBottomColor: primary }}
          />
        </View>
        <View style={{ flex: 1 }}></View>
        <View style={{ marginTop: 30 }}>
          <MyText style={{ marginBottom: 5 }}>
            {translate("app language")}
          </MyText>
          <Dropdown
            items={items}
            setSelected={setSelected}
            selected={selected.selected}
          />
        </View>
      </View>
    </SafeAreaView>
  );
}
